<template>
  <div class="note">
    <div v-if="!isEdit">
      <el-card class="note-card" shadow="never">
        <div>
          <i
            class="date"
          >{{format( Date.parse(note.DateCreated), 'MM/DD/YYYY', { awareOfUnicodeTokens: true }) }}</i>
        </div>
        <div>{{note.Note}}</div>
        <el-button type="text" @click="onEdit">{{isEdit? 'save': 'edit'}}</el-button>
        <el-button class="del-button" type="text" @click="onDelete">delete</el-button>
      </el-card>
    </div>
    <div v-else>
      <el-input type="textarea" v-model="newNote.Note" placeholder="Add a new note..."></el-input>
      <el-button round size="small" @click="onSaveEdit" :disabled="newNote.length ===0">Save Note</el-button>
    </div>
  </div>
</template>

<script>
import { format, parse } from 'date-fns'

export default {
  props: ['note'],
  data() {
    return {
      format,
      parse,
      isEdit: false,
      newNote: null
    }
  },
  methods: {
    onDelete() {
      this.$confirm(
        'This will permanently delete this note. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.$emit('deleteNote', this.note)
        })
        .catch(() => {})
    },
    onSaveEdit() {
      this.$emit('editNote', this.note)
      this.isEdit = false
    },
    onEdit() {
      this.newNote = this.note
      this.isEdit = true
    }
  }
}
</script>

<style scoped>
.date {
  color: grey;
}
.del-button {
  margin-top: -20px;
}
.note {
  margin-bottom: 20px;
}
.del-button {
  color: red;
}
</style>
<style>
.note-card .el-card__body {
  padding: 0px;
}
</style>


